module.exports = __webpack_public_path__ + "27268508ba8e6d01e72c3d777e7dc377.pdf";